import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ResolveEnd, ResolveStart, Router } from '@angular/router';
import { combineLatest, map, Observable, startWith } from 'rxjs';
import { OperationInfoService } from '../operation-info.service';

@Component({
  selector: 'app-global-spinner',
  templateUrl: './global-spinner.component.html',
  styleUrls: ['./global-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSpinnerComponent {
  private isPageResolving$: Observable<boolean> = inject(Router).events.pipe(
    map((event) => {
      switch (true) {
        case event instanceof ResolveStart:
          return true;

        case event instanceof ResolveEnd:
          return false;

        default:
          return false;
      }
    }),
  );

  private isOperationInProgress$: Observable<boolean> = inject(OperationInfoService).isLoadingGlobalSpinner$;

  public readonly isLoading$ = combineLatest([
    this.isPageResolving$.pipe(startWith(false)),
    this.isOperationInProgress$.pipe(startWith(false)),
  ]).pipe(map(([inProgress, isResolving]: [boolean, boolean]) => inProgress || isResolving));
}
